import { render, staticRenderFns } from "./akutansi.vue?vue&type=template&id=7cb801a3&scoped=true"
import script from "./akutansi.vue?vue&type=script&lang=js"
export * from "./akutansi.vue?vue&type=script&lang=js"
import style0 from "./akutansi.vue?vue&type=style&index=0&id=7cb801a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb801a3",
  null
  
)

export default component.exports